"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PreviewFrame = (function () {
    function PreviewFrame(createUi, $sce, di) {
        if (di.has("url")) {
            this._ui = createUi(require("./PreviewFrame.html"), {
                trustedUrl: $sce.trustAsResourceUrl(di.get("url")),
            });
        }
        else {
            this._ui = createUi(require("./PreviewFrame.html"), {});
        }
    }
    Object.defineProperty(PreviewFrame.prototype, "ui", {
        get: function () {
            return this._ui;
        },
        enumerable: false,
        configurable: true
    });
    return PreviewFrame;
}());
exports.default = PreviewFrame;
